// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"d499adc5","outerContainer":"e18fd8e4","secondaryToolbar":"_40909c56","doorHangerRight":"_06b3d5d6","toolbarContainer":"_6e2e06b6","toolbarViewerMiddle":"_95652f6d","progressBar":"a4a6fb1e","back-to-application":"cec14ec8","section":"_656d7a38","link":"fe620c2e"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Healthboard/Components/InsuranceToDoTaskPopup/components/common/DescriptionSection/index.styl
// module id = 4971
// module chunks = 39